const defaultSubscriptions = [
  "channel.charity_campaign.donate",
  "channel.charity_campaign.progress",
];

var clientId = process.env.REACT_APP_TWITCH_CLIENT_ID;
console.log("top CI", clientId);

let twitchOAuthToken = null;
export function setTwitchOAuthToken(token) {
  twitchOAuthToken = token;
  console.log("top", twitchOAuthToken);
}

/**
 *
 * @param {Subscription[]} subscriptions
 */
export async function subscribeAll(session_id, subscriptions) {
  await Promise.allSettled(subscriptions.map((s) => subscribe(session_id, s)));
}

/**
 *
 * @param {string[]} subs
 */
export async function resubscribeAll(
  session_id,
  user_id,
  subscriptions = defaultSubscriptions
) {
  const subs = await getSubs();
  await Promise.all(
    subscriptions.map(async (s) => {
      const sub = subs.find((sub) => sub.type == s);
      //if (!sub) {
      await subscribe(session_id, {
        type: s,
        version: "1",
        condition: { broadcaster_user_id: user_id },
      });
      //}
    })
  );
}

/**
 *
 * @param {string} session_id
 * @param {*} param1
 * @returns {Promise<{data:SubscriptionInfo[],total:number,total_cost:number,max_total_cost:number}>}
 */
export async function subscribe(session_id, { type, version, condition }) {
  const body = {
    type,
    version,
    condition,
    transport: {
      method: "websocket",
      session_id: session_id,
    },
  };
  return await (
    await fetch("https://api.twitch.tv/helix/eventsub/subscriptions", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Client-ID": clientId,
        Authorization: "Bearer " + twitchOAuthToken,
      }),
      body: JSON.stringify(body),
    })
  ).json();
}

/**
 *
 * @returns {Promise<SubscriptionInfo[]>}
 */
export async function getSubs() {
  /**@type {any[]} */
  const subs = (
    await (
      await fetch("https://api.twitch.tv/helix/eventsub/subscriptions", {
        method: "GET",
        headers: new Headers({
          "Client-ID": clientId,
          Authorization: "Bearer " + twitchOAuthToken,
        }),
      })
    ).json()
  ).data;
  return subs;
}
//		subscribe('channel.charity_campaign.donate', '1', { broadcaster_user_id: sessionStorage.user_id });

export async function unsubscribe(id) {
  await fetch("https://api.twitch.tv/helix/eventsub/subscriptions?id=" + id, {
    method: "DELETE",
    headers: new Headers({
      "Client-ID": clientId,
      Authorization: "Bearer " + twitchOAuthToken,
    }),
  });
}
/**
 *
 * @param {string} user_id
 * @returns {Promise<CharityCampaign[]>}
 */
export async function getCharityCamps(user_id) {
  return (
    await (
      await fetch(
        `https://api.twitch.tv/helix/charity/campaigns?broadcaster_id=${user_id}`,
        {
          headers: new Headers({
            "Client-ID": clientId,
            Authorization: "Bearer " + twitchOAuthToken,
          }),
        }
      )
    ).json()
  ).data;
}

/**
 * Gets the user data of the login name.
 * If login name is null, returns the data of the OAuth token's user
 * @param {string} login
 * @returns {Promise<UserData>}
 */
export async function getUserData(login = null) {
  const url = new URL("https://api.twitch.tv/helix/users");
  if (login) url.searchParams.append("login", login);
  const user = await (
    await fetch(url.toString(), {
      method: "GET",
      headers: new Headers({
        Accept: "application/json",
        "Client-ID": clientId,
        Authorization: "Bearer " + twitchOAuthToken,
      }),
    })
  ).json();
  console.log("bottom", twitchOAuthToken);
  console.log("bottom CI", clientId);
  console.log("twitch user", user);
  if (user.error) {
    throw new Error(user.error.message);
  }
  if (!login && user && user.data && user.data.length > 0) {
    sessionStorage.user_id = user.data[0].id;
  }
  return user?.data?.[0];
}

// Source: https://www.thepolyglotdeveloper.com/2015/03/create-a-random-nonce-string-using-javascript/
export function nonce(length) {
  let text = "";
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}
/**
 *
 * @returns {Promise<{pagination:{cursor:string},data:Donation[]}>}
 */
export async function getHistoricalDonations(
  user_id,
  opts = { first: 20, cursor: null }
) {
  const { first, cursor } = opts;
  const cursorParam = cursor ? `&after=${cursor}` : "";
  const firstParam = first ? `&first=${first}` : "";
  return await (
    await fetch(
      `https://api.twitch.tv/helix/charity/donations?broadcaster_id=${user_id}${firstParam}${cursorParam}`,
      {
        method: "GET",
        headers: new Headers({
          "Client-ID": clientId,
          Authorization: "Bearer " + twitchOAuthToken,
        }),
      }
    )
  ).json();
}
/**
 *
 * @param {Currency} currency
 * @returns
 */
export function currencyToAmount(currency) {
  return currency.value / Math.pow(10, currency.decimal_places);
}
/**
 *
 * @param {Currency} currency
 */
export function formatCurrency(currency) {
  new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: currency.currency,
  }).format(currencyToAmount(currency));
}

/**
 * @typedef UserData
 * @property {string} id
 * @property {string} login
 * @property {string} display_name
 * @property {string} type
 * @property {string} broadcaster_type
 * @property {string} description
 * @property {string} profile_image_url
 * @property {string} offline_image_url
 * @property {number} view_count
 * @property {string} email
 * @property {string} created_at
 */

/**
 * @typedef Subscription
 * @property {string} type
 * @property {string} version
 * @property {object} condition
 *
 */

/**
 * @typedef CharityCampaign
 * @property {string} id
 * @property {string} broadcaster_id
 * @property {string} broadcaster_login
 * @property {string} broadcaster_name
 * @property {string} charity_name
 * @property {string} charity_description
 * @property {string} charity_website
 * @property {Currency} current_amount
 * @property {Currency} target_amount
 *
 * @typedef Currency
 * @property {string} currency
 * @property {number} value
 * @property {number} decimal_places
 */

/**
 * @typedef Donation
 * @property {string} id
 * @property {string} campaign_id
 * @property {string} user_id
 * @property {string} user_login
 * @property {string} user_name
 * @property {Currency} amount
 */

/**
 * @typedef SubscriptionInfo
 * @property {string} id
 * @property {string} status
 * @property {string} type
 * @property {string} version
 * @property {object} condition
 * @property {string} created_at
 * @property {object} transport
 * @property {number} cost
 */
